import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { Dialog, DialogContent, DialogActions } from "@mui/material";
import { Stack, Button } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { EmployeeSelect } from "@icoach/components";
import useDeviceOrderApi from "@apis/useDeviceOrderApi";
import { refIsRequiredError } from "@util/utils";

const SmartFitnessBandQuitDeleteDialog = React.forwardRef((props, ref) => {
	const { sourceData: sourceDataProps, open: openProps = false, onClose: onCloseProps, refresh: doRefreshProps } = props;
	const [options, setOptions] = useState({ employeeOptions: [] });
	const { getDeviceOrderApplyOptionsApi, deleteDeviceOrderEffectionApi } = useDeviceOrderApi();
	const employeeRef = useRef(null);
	const { employeeOptions } = options;
	const { effectID } = sourceDataProps || {};

	const intiGetOptions = async () => {
		const resp = await getDeviceOrderApplyOptionsApi();
		if (resp) setOptions(resp);
	};

	const handleSubmitClick = () => {
		if (refIsRequiredError(employeeRef)) return;
		doQuitDeleteApi(effectID, employeeRef.current.getResult());
	};

	const doQuitDeleteApi = async (id, employeeID) => {
		const resp = await deleteDeviceOrderEffectionApi(id, employeeID);
		if (resp) {
			// 要先刷新再關閉視窗
			doRefreshProps();
			onCloseProps();
		}
	};

	useEffect(
		() => {
			if (openProps) intiGetOptions();
			else setOptions({ employeeOptions: [] });
		},
		// eslint-disable-next-line
		[openProps]
	);

	if (!openProps) return null;

	return (
		<Dialog className={clsx("simple-content", "dialog")} PaperProps={{ className: "wx-40rem" }} open={openProps} fullWidth>
			<GradientColorHeader onClose={onCloseProps}>取消退訂智能系統</GradientColorHeader>
			<DialogContent>
				<Stack spacing={2} direction="column">
					<EmployeeSelect ref={employeeRef} options={employeeOptions} label="經辦教練" fullWidth required />
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleSubmitClick}>
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default SmartFitnessBandQuitDeleteDialog;